
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/platform/sales-and-marketing",
      function () {
        return require("private-next-pages/platform/sales-and-marketing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/platform/sales-and-marketing"])
      });
    }
  